import {FiCheck} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {ColumnSpec} from "@/components/table/Table.types.ts";
import {EllipsisText} from "@/components/typography/EllipsisText.tsx";
import {Subscriber, SubscriptionType} from "@/lib/types/statuspages.ts";

import styles from "./StatusPageSubscribersTable.module.scss";

export const specs: Record<Exclude<SubscriptionType, SubscriptionType.RSS>, ColumnSpec<Subscriber>[]> = {
  [SubscriptionType.EMAIL]: [
    {
      fieldName: "target",
      fieldTitle: "Subscriber Email",
      enableSorting: true,
      accessor: (obj: Subscriber) => (
        <div className={"d-flex"}>
          <EllipsisText className={"d-block text-nowrap"} toolTip={obj.target}>
            {obj.target}
          </EllipsisText>
        </div>
      ),
      meta: {
        headerClassName: styles.targetColumn,
        columnClassName: styles.targetColumn,
      },
    },
  ],
  [SubscriptionType.SMS]: [
    {
      fieldName: "target",
      fieldTitle: "Subscriber Phone No.",
      enableSorting: true,
      accessor: (obj: Subscriber) => obj.target,
      meta: {
        headerClassName: styles.targetColumn,
        columnClassName: styles.targetColumn,
      },
    },
    {
      fieldName: "status",
      fieldTitle: "Subscription Status",
      accessor: (obj: Subscriber) =>
        obj.status === "Active" ? (
          <>
            <span className="pulse-color-green-500">
              <Icon icon={FiCheck} display={"inline"} />
            </span>
            Active
          </>
        ) : (
          obj.status
        ),
    },
  ],
  [SubscriptionType.SLACK]: [
    {
      fieldName: "slack_integration__workspace_name",
      fieldTitle: "Slack Workplace",
      enableSorting: true,
      accessor: (obj: Subscriber) => obj.slack_integration?.workspace_name,
    },
    {
      fieldName: "slackChannel",
      fieldTitle: "Slack Channel",
      accessor: (obj: Subscriber) => obj.slack_integration?.channel_name,
    },
  ],
  [SubscriptionType.WEBHOOK]: [
    {
      fieldName: "target",
      fieldTitle: "Subscriber Webhook URL",
      enableSorting: true,
      accessor: (obj: Subscriber) => (
        <div className={"d-flex"}>
          <EllipsisText className={"d-block text-nowrap"} toolTip={obj.target}>
            {obj.target}
          </EllipsisText>
        </div>
      ),
      meta: {
        headerClassName: styles.targetColumn,
        columnClassName: styles.targetColumn,
      },
    },
  ],
};

export const subscriptionTypeNames = {
  [SubscriptionType.EMAIL]: "Email",
  [SubscriptionType.SLACK]: "Slack",
  [SubscriptionType.SMS]: "SMS",
  [SubscriptionType.WEBHOOK]: "Webhook",
  [SubscriptionType.RSS]: "RSS",
};
